import { TERMS_MODULE_OPTINS } from "../../../../components/modules/compliance/config";
import { flowDisabledLoan } from "../../flowDisabledLoan";
import { flowBREnabledPictureId } from "../../flowBREnabledPictureId";
import { flowWelcomeAndTerms } from "../../flowWelcomeAndTerms";
import { DISABLED_LOAN_STATUS } from "../constants/DisabledLoanStatus";

export const ktuinFlows = [
  {
    ...flowDisabledLoan,
    condition: (processState, authState) => {
      return DISABLED_LOAN_STATUS.includes(processState?.loan?.status);
    },
  },
  {
    ...flowWelcomeAndTerms,
    condition: (processState, authState) => {
      return (
        !processState.participant.participantId ||
        !processState?.optIns ||
        processState?.optIns?.conditions_indicated
          .filter((condition) =>
            TERMS_MODULE_OPTINS.includes(condition.condition_type)
          )
          .some((condition) => condition.required && condition.checked !== true)
      );
    },
  },
  {
    ...flowBREnabledPictureId,
    condition: () => {
      return true;
    },
  },
];
